"use client";

import { useEffect } from "react";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"] as const;

function setCookie(key: string, value: string, rootDomain: string) {
  const maxAge = 90 * 24 * 60 * 60;
  document.cookie = `${key}=${encodeURIComponent(value)};domain=.${rootDomain};path=/;max-age=${maxAge};SameSite=Lax`;
}

function clearUtmCookies(rootDomain: string) {
  for (const key of UTM_KEYS) {
    document.cookie = `${key}=;domain=.${rootDomain};path=/;max-age=0;SameSite=Lax`;
  }
}

export function UtmTracker() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const rootDomain = window.location.hostname.split(".").slice(-2).join(".");
    const ref = params.get("ref") || params.get("referral");
    const gclid = params.get("gclid");
    const yclid = params.get("yclid");
    const hasUtm = UTM_KEYS.some((key) => params.has(key));

    if (gclid) setCookie("gclid", gclid, rootDomain);
    if (yclid) setCookie("yclid", yclid, rootDomain);
    if (ref) setCookie("referral_code", ref, rootDomain);

    if (hasUtm) {
      clearUtmCookies(rootDomain);
      for (const key of UTM_KEYS) {
        const value = params.get(key);
        if (value) setCookie(key, value, rootDomain);
      }
      return;
    }

    if (ref) {
      clearUtmCookies(rootDomain);
      setCookie("utm_source", "referral", rootDomain);
      setCookie("utm_medium", "invite", rootDomain);
      setCookie("utm_campaign", `ref_${ref}`, rootDomain);
      return;
    }

    if (!document.referrer) return;
    try {
      const refUrl = new URL(document.referrer);
      const refHost = refUrl.hostname.toLowerCase();
      if (refHost.includes(rootDomain) || refHost === "localhost") return;

      clearUtmCookies(rootDomain);
      if (refHost.includes("google")) {
        setCookie("utm_source", "google", rootDomain);
        setCookie("utm_medium", "organic", rootDomain);
        setCookie("utm_campaign", "search", rootDomain);
        const term = refUrl.searchParams.get("q");
        if (term) setCookie("utm_term", term, rootDomain);
        return;
      }

      if (refHost.includes("bing.com")) {
        setCookie("utm_source", "bing", rootDomain);
        setCookie("utm_medium", "organic", rootDomain);
        setCookie("utm_campaign", "search", rootDomain);
        const term = refUrl.searchParams.get("q");
        if (term) setCookie("utm_term", term, rootDomain);
        return;
      }

      setCookie("utm_source", "referral", rootDomain);
      setCookie("utm_medium", "referral", rootDomain);
      setCookie("utm_campaign", refHost.replace("www.", ""), rootDomain);
    } catch {
      // Ignore malformed referrers.
    }
  }, []);

  return null;
}
